const useCsrfToken = () =>
  document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ??
  ''

export default useCsrfToken
